/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Write_PlaceholderInputs */

const en_us2_board_write_placeholder = /** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. writing down the load of every set helped me progress.`)
};

const pt_br2_board_write_placeholder = /** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: anotar a carga de cada série me ajudou a progredir.`)
};

const pt_pt2_board_write_placeholder = /** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: anotar a carga de cada série me ajudou a progredir.`)
};

/** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */
const es_419_board_write_placeholder = en_us2_board_write_placeholder;

/** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */
const fr_fr2_board_write_placeholder = en_us2_board_write_placeholder;

/** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */
const de_de2_board_write_placeholder = en_us2_board_write_placeholder;

/** @type {(inputs: Board_Write_PlaceholderInputs) => LocalizedString} */
const it_it2_board_write_placeholder = en_us2_board_write_placeholder;

/**
* | output |
* | --- |
* | "E.g. writing down the load of every set helped me progress." |
*
* @param {Board_Write_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_write_placeholder = /** @type {((inputs?: Board_Write_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Write_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_write_placeholder(inputs)
	if (locale === "es-419") return es_419_board_write_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_board_write_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_board_write_placeholder(inputs)
	if (locale === "de-DE") return de_de2_board_write_placeholder(inputs)
	if (locale === "it-IT") return it_it2_board_write_placeholder(inputs)
	return en_us2_board_write_placeholder(inputs)
});
export { board_write_placeholder as "board.write_placeholder" }